<template>
  <div class="pane_body">
    <v-card flat color="rgb(255 255 245)">
      <v-toolbar flat dense class="breads">
        <v-breadcrumbs :items="breadcrumb">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :to="item.to" :disabled="item.disabled">
              {{ item.text.toUpperCase() }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              x-small
              text
              v-on="on"
              color="success"
              @click.stop="doctypeNewDialog = true"
            >
              new
            </v-btn>
          </template>
          <span>Create new Document Type</span>
        </v-tooltip>
        <DocTypeNew
          :doctypeNewDialog="doctypeNewDialog"
          @closeNew="closeNew"
          @submitNew="submitNew"
        />

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon text v-on="on" color="info" @click="lists()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh</span>
        </v-tooltip>
      </v-toolbar>
    </v-card>

    <v-container>
      <v-card color="transparent" flat>
        <v-card flat rounded="0">
          <v-card-text>
            <v-data-table
              loader-height="2"
              :loading="loading"
              :headers="headers"
              :items="documentypeList"
              :items-per-page="8"
              :footer-props="{
                itemsPerPageOptions: [8, 16, 24],
                // showFirstLastPage: true,
                // firstIcon: 'mdi-arrow-collapse-left',
                // lastIcon: 'mdi-arrow-collapse-right',
                // prevIcon: 'mdi-minus',
                // nextIcon: 'mdi-plus'
              }"
            >
              <template v-slot:item.created="{ item }">
                {{ item.created | myDating }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  @click.stop="$set(doctypeViewDialog, item.id, true)"
                  text
                  x-small
                  color="primary"
                >
                  view
                </v-btn>
                <DocTypeView
                  v-if="doctypeViewDialog[item.id]"
                  :myId="item.id"
                  :name="item.name"
                  :doctypeViewDialog="doctypeViewDialog[item.id]"
                  @closeView="closeView"
                />

                <v-btn
                  @click.stop="$set(doctypeEditDialog, item.id, true)"
                  text
                  x-small
                  color="success"
                >
                  edit
                </v-btn>
                <DocTypeEdit
                  v-if="doctypeEditDialog[item.id]"
                  :myId="item.id"
                  :name="item.name"
                  :doctypeEditDialog="doctypeEditDialog[item.id]"
                  @closeEdit="closeEdit"
                  @submitEdit="submitEdit"
                />

                <v-btn
                  text
                  x-small
                  color="pink"
                  @click.stop="$set(doctypeRemoveDialog, item.id, true)"
                  >DELETE
                </v-btn>
                <DocTypeRemove
                  v-if="doctypeRemoveDialog[item.id]"
                  :myId="item.id"
                  :name="item.name"
                  :doctypeRemoveDialog="doctypeRemoveDialog[item.id]"
                  @closeRemove="closeRemove"
                  @submitRemove="submitRemove"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card>
      <v-snackbar
        :color="snack.color"
        v-model="snack.bar"
        :multi-line="snack.multiLine"
      >
        {{ snack.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snack.bar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import Restful from "@/services/RestFul";
  import DocTypeNew from "./../../../components/settings/doctypes/newone.vue";
  import DocTypeView from "./../../../components/settings/doctypes/view.vue";
  import DocTypeEdit from "./../../../components/settings/doctypes/edit.vue";
  import DocTypeRemove from "../../../components/settings/doctypes/remove";
  export default {
    components: {
      DocTypeNew,
      DocTypeView,
      DocTypeEdit,
      DocTypeRemove,
    },
    data() {
      return {
        loading: false,
        doctypeRemoveDialog: {},
        doctypeNewDialog: false,
        doctypeViewDialog: {},
        doctypeEditDialog: {},
        breadcrumb: [
          {
            text: "Dashboard",
            disabled: false,
            to: { name: "umohe_admin.dash" },
          },
          {
            text: "Settings",
            disabled: true,
          },
          {
            text: "Document Types",
            disabled: true,
          },
        ],
        snack: {
          color: "info",
          multiLine: true,
          bar: false,
          text: "Processing ... ",
        },
        headers: [
          { text: "name", value: "name" },
          { text: "description", value: "description" },
          { text: "created", value: "created" },
          { text: "actions", value: "actions", align: "center" },
        ],
        documentypeList: [],
      };
    },
    created() {
      this.lists();
    },
    methods: {
      lists() {
        this.loading = true;
        let self = this;
        Restful.general.documentType
          .list()
          .then((response) => {
            console.log(response);
            this.documentypeList = response.data;
            this.loading = false;
          })
          .catch((error) => {
            console.log(error.response);
            self.loading = false;
          });
      },
      closeView(p) {
        this.$set(this.doctypeViewDialog, p.id, p.state);
      },
      closeEdit(p) {
        this.$set(this.doctypeEditDialog, p.id, p.state);
      },
      submitEdit(p) {
        this.snack.bar = true;
        console.log(p.data);
        console.log(p.id);

        let self = this;
        Restful.general.documentType
          .update(p.id, p.data)
          .then((response) => {
            console.log(response.data);
            this.snack.color = "success";
            this.snack.text = response.data;
            this.lists();
          })
          .catch((error) => {
            console.log(error.response);
            self.snack.color = "error";
            self.snack.text = error.response.data;
          });

        this.$set(this.doctypeEditDialog, p.id, p.state);
      },
      closeNew(p) {
        console.log(p);
        this.doctypeNewDialog = p.state;
      },
      submitNew(p) {
        this.snack.bar = true;
        console.log(p);
        let self = this;
        Restful.general.documentType
          .create(p.data)
          .then((response) => {
            this.snack.color = "success";
            this.snack.text = response.data;
            this.lists();
          })
          .catch((error) => {
            console.log(error.response);
            this.snack.color = "error";
            self.snack.text = error.response.data;
          });

        this.doctypeNewDialog = p.state;
      },
      closeRemove(p) {
        this.$set(this.doctypeRemoveDialog, p.id, p.state);
      },
      submitRemove(p) {
        this.snack.bar = true;
        console.log(p.id);

        let self = this;
        Restful.general.documentType
          .remove(p.id)
          .then((response) => {
            console.log(response.data);
            this.snack.color = "success";
            this.snack.text = response.data;
            this.lists();
          })
          .catch((error) => {
            console.log(error.response);
            self.snack.color = "error";
            self.snack.text = error.response.data;
          });
        this.$set(this.doctypeRemoveDialog, p.id, p.state);
      },
    },
  };
</script>
